import { makeStyles } from '@rbx/ui';

type useStylesProps = { ratio?: number };

const useMarkdownImageStyles = makeStyles<useStylesProps>()((theme, { ratio }) => ({
  image: {
    maxWidth: '100%',
    height: 'auto',
    marginBottom: 16,
    // toFixed convert the ratio to string
    // if aspectRatio is a number, there will be a 'px' appended to the end
    // e.g. '{ aspectRatio: 1 }' will be compiled to 'aspect-ratio: 1px'
    ...(ratio ? { aspectRatio: ratio.toFixed(2) } : {}),
  },
}));

export default useMarkdownImageStyles;
